import { useMemo } from 'react';

export function useItemValidationModule({ novoProduto, profile, operacaoParametros, OptionsEmbalagem = [] }) {
    const state = useMemo(() => {
        const ignoraRegraPrecoDesconto =
            novoProduto?.ignoraRegraPrecoDesconto === true ||
            novoProduto?.permitePrecoAbaixoTabela === true ||
            profile?.layout === 'industria';

        const usaTabelaPreco = !!profile?.parametros?.itens?.usaTabelaPreco;

        const valorUnit = Number(novoProduto?.valorUnitario || 0);
        const quantidade = Number(novoProduto?.quantidade || 0);

        const tabelaOk = usaTabelaPreco ? !!novoProduto?.tabelaPrecoId : true;
        const produtoOk = !!novoProduto?.produtoId;
        const embalagemOk = !!novoProduto?.embalagemId;
        const qtdOk = quantidade > 0;

        // aqui libera somente a regra de preço
        const precoOk = ignoraRegraPrecoDesconto ? true : valorUnit > 0 || !!operacaoParametros?.ultimoCusto;

        const embalagemSelecionada =
            novoProduto?.Embalagem ||
            novoProduto?.embalagem ||
            OptionsEmbalagem.find((item) => Number(item.id) === Number(novoProduto?.embalagemId));

        const aceitaFracao = embalagemSelecionada?.aceitaFracao === true;
        const quantidadeFracionada = quantidade > 0 && !Number.isInteger(quantidade);
        const bloqueadoPorFracao = qtdOk && !aceitaFracao && quantidadeFracionada;

        let motivoBloqueioItem = null;

        if (!tabelaOk) motivoBloqueioItem = 'Tabela de preço obrigatória.';
        else if (!produtoOk) motivoBloqueioItem = 'Produto obrigatório.';
        else if (!embalagemOk) motivoBloqueioItem = 'Embalagem obrigatória.';
        else if (!qtdOk) motivoBloqueioItem = 'Quantidade obrigatória.';
        else if (!precoOk) motivoBloqueioItem = 'Preço obrigatório.';
        else if (bloqueadoPorFracao) motivoBloqueioItem = 'A embalagem selecionada não aceita quantidade fracionada.';

        const podeSalvarItemBase = tabelaOk && produtoOk && embalagemOk && qtdOk && precoOk && !bloqueadoPorFracao;

        const mensagemItem = bloqueadoPorFracao
            ? {
                  key: `fracao-bloqueada-${Date.now()}`,
                  texto: 'A embalagem selecionada não aceita quantidade fracionada.',
                  tipo: 'warning',
                  tempo: 4,
              }
            : null;

        return {
            podeSalvarItemBase,
            bloqueadoPorFracao,
            motivoBloqueioItem,
            mensagemItem,
        };
    }, [
        novoProduto?.tabelaPrecoId,
        novoProduto?.produtoId,
        novoProduto?.embalagemId,
        novoProduto?.quantidade,
        novoProduto?.valorUnitario,
        novoProduto?.Embalagem,
        novoProduto?.embalagem,
        novoProduto?.ignoraRegraPrecoDesconto,
        novoProduto?.permitePrecoAbaixoTabela,
        OptionsEmbalagem,
        profile?.parametros?.itens?.usaTabelaPreco,
        operacaoParametros?.ultimoCusto,
    ]);

    return { state };
}
